"use client"

import { useEffect, useState } from "react"
import { Kbd } from "../ui/kbd"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table"
import { DomainSchema } from "@/schemas/domain.schema"
import { z } from "zod";
import { getVersionsWithSubversions } from "@/services/versions.service"
import { dropdownCss } from "../ui/dropdown"
import UpgradeModal from "./UpgradeModal"
import { getNormalDomains } from "@/services/domains.service"
import { VersionsSchema } from "@/schemas/versions.schema"

interface Props {
    domains: z.infer<typeof DomainSchema>[]
}

export default function UpgradeTable(props: Props) {
    const [currentDomains, setCurrentDomains] = useState(props.domains);
    const [versions, setVersions] = useState<z.infer<typeof VersionsSchema>[]>([]);
    const [updateData, setUpdateData] = useState(false);

    const getVersions = async () => {
        const result = await getVersionsWithSubversions();
        setVersions(result);
    }

    const registerSelectChange = (e: React.FormEvent<HTMLSelectElement>, domain: z.infer<typeof DomainSchema>) => {
        const target = e.currentTarget;
        const value = target.value;
        // Check if that version object has subVersions
        const keySubVersions = versions.find(e => e.Title == value)?.SubVersions;

        // If it does, generate the html content for a new dropdown that will appear next to it
        if(keySubVersions?.length !== 0){
            const subVersionDiv = document.getElementById("subVersionDiv-" + domain.ID);

            // Clear the div in case there is already some content in it
            while(subVersionDiv?.firstChild){
                subVersionDiv.removeChild(subVersionDiv.firstChild);
            }
            let options = '<select class="'+ dropdownCss +'" id="subVersion-'+ domain.ID +'" name="subVersion" aria-label="Sub Versions">';
            keySubVersions?.forEach(element => {
                options += '<option value='+ element.Title +'>'+ element.Title +'</option>';
            }); 
            options += '</select>';
            document.getElementById("subVersionDiv-" + domain.ID)!.innerHTML = options;
        } else {
            // If we select a version that doesn't have any subversions, clear the div content
            const subVersionDiv = document.getElementById("subVersionDiv-" + domain.ID);
            while(subVersionDiv?.firstChild){
                subVersionDiv.removeChild(subVersionDiv.firstChild);
            }
        }
    }

    const updateDomains = async () => {
        const domains = await getNormalDomains();
        setCurrentDomains(domains);
        setUpdateData(false); 
    }

    if(updateData){
        updateDomains();
               
    }

    useEffect(() => {
        if(currentDomains.length === 0){
            setCurrentDomains(props.domains);
        }

        if(versions.length === 0){
            getVersions();
        }
    }, [currentDomains, props.domains, versions]);
    return <div>
        <h1 className="text-xl font-bold text-black dark:text-white mb-2">
            Upgrade
        </h1>
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>#</TableHead>
                    <TableHead>Navn / database</TableHead>
                    <TableHead>Website / mappe</TableHead>
                    <TableHead>Pakke</TableHead>
                    <TableHead>Version</TableHead>
                    <TableHead>Upgrade To</TableHead>
                    <TableHead>Upgrade</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {currentDomains?.map((domain, _index) => (
                    <TableRow key={domain.ID}>
                        <TableCell>{domain.ID}</TableCell>
                        <TableCell>{domain.Name} <Kbd>{domain.DBRel}</Kbd></TableCell>
                        <TableCell>{domain.Website} <Kbd>{domain.Folder}</Kbd></TableCell>
                        <TableCell>{domain.Package}</TableCell>
                        <TableCell>{domain.Version}</TableCell>
                        <TableCell>
                            <select 
                                name="" 
                                id={"upgradeVersion-" + domain.ID} 
                                className={dropdownCss}
                                onChange={(e: React.FormEvent<HTMLSelectElement>) => registerSelectChange(e, domain)}>
                                {versions.map(version => {
                                    return <option key={version.ID} value={version.Title}>{version.Title}</option>
                                })}
                            </select>
                            <div id={"subVersionDiv-"+domain.ID}>
                            </div>
                        </TableCell>
                        <TableCell>
                            <UpgradeModal
                                domain={domain}
                                updateData={updateDomains}
                            />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </div> 
}